import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { SystemRole } from '../models';

export function roleGuard(...allowedRoles: SystemRole[]): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    return auth.ensureCurrentUser().pipe(
      map((user) => {
        if (user?.systemRole && allowedRoles.includes(user.systemRole)) {
          return true;
        }
        return router.createUrlTree(['/dashboard']);
      }),
    );
  };
}
